import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { RefreshCw, ArrowRight, Check } from "lucide-react";

export default function TradeIn() {
  const [form, setForm] = useState({ name: "", phone: "", email: "", device: "", condition: "good", message: "" });
  const [submitting, setSubmitting] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await api.post("/leads", { type: "tradein", name: form.name, phone: form.phone, email: form.email, device: form.device, message: form.message, extra: { condition: form.condition } });
      toast.success("Trade-in request received. We'll send you a quote shortly.");
      setForm({ name: "", phone: "", email: "", device: "", condition: "good", message: "" });
    } catch {
      toast.error("Could not send. Please try again.");
    } finally { setSubmitting(false); }
  };
  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16" data-testid="tradein-page">
      <div className="grid lg:grid-cols-2 gap-16 items-start">
        <div>
          <div className="overline text-[#1a2d5e]">Trade-in Program</div>
          <h1 className="font-display font-black text-5xl lg:text-6xl mt-3 text-[#0b1838] tracking-tighter">Old device.<br/>New credit.</h1>
          <p className="mt-5 text-lg text-slate-600 leading-relaxed max-w-lg">Every brand, every model. Tell us what you have — we&apos;ll give you a fair, no-pressure quote you can use as instant credit toward your next upgrade.</p>
          <ul className="mt-8 space-y-3 text-slate-700">
            {["Same-day quote on most devices", "Best price guaranteed — beats online buyback", "We take any brand & any condition", "Use credit instantly in any branch or online"].map((t) => (
              <li key={t} className="flex items-start gap-3"><Check className="text-[#1a2d5e] mt-1" size={18} />{t}</li>
            ))}
          </ul>
        </div>

        <form onSubmit={submit} className="bg-slate-50 border border-slate-200 rounded-2xl p-8" data-testid="trade-in-form">
          <div className="flex items-center gap-3 mb-6"><RefreshCw className="text-[#1a2d5e]" /><div className="font-display font-bold text-xl">Get my quote</div></div>
          <div className="grid gap-4">
            <input required placeholder="Your name" data-testid="tradein-name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="px-4 py-3 border border-slate-300 rounded-lg bg-white" />
            <div className="grid sm:grid-cols-2 gap-4">
              <input required placeholder="Phone" data-testid="tradein-phone" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} className="px-4 py-3 border border-slate-300 rounded-lg bg-white" />
              <input type="email" placeholder="Email (optional)" data-testid="tradein-email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="px-4 py-3 border border-slate-300 rounded-lg bg-white" />
            </div>
            <input required placeholder="Device — e.g. iPhone 13 Pro Max 256GB" data-testid="tradein-device" value={form.device} onChange={(e) => setForm({ ...form, device: e.target.value })} className="px-4 py-3 border border-slate-300 rounded-lg bg-white" />
            <select data-testid="tradein-condition" value={form.condition} onChange={(e) => setForm({ ...form, condition: e.target.value })} className="px-4 py-3 border border-slate-300 rounded-lg bg-white">
              <option value="like_new">Like new — barely used</option>
              <option value="good">Good — minor wear</option>
              <option value="fair">Fair — visible wear, fully working</option>
              <option value="broken">Broken — for parts</option>
            </select>
            <textarea rows={3} placeholder="Anything we should know?" data-testid="tradein-message" value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className="px-4 py-3 border border-slate-300 rounded-lg bg-white" />
            <button disabled={submitting} data-testid="tradein-submit" type="submit" className="px-6 py-4 bg-[#1a2d5e] text-white font-semibold rounded-lg hover:bg-[#0b1838] transition-colors disabled:opacity-60 inline-flex items-center justify-center gap-2">{submitting ? "Sending…" : <>Get my quote <ArrowRight size={16} /></>}</button>
          </div>
        </form>
      </div>
    </div>
  );
}
